module.exports = __webpack_public_path__ + "images/klinkerof-fc31e8a36188a9caa418a5e690d51394.jpg";